import type { FC } from 'react';
import { useUserAgent } from 'src/lib/customHooks/useUserAgent';
import { Platforms } from 'src/lib/userAgent';
import { type IconProps, IconShareAndroid, IconShareGeneral, IconShareIOS } from './Icons';

export const IconSharePlatformAware: FC<IconProps> = (props) => {
  const { platform } = useUserAgent();

  if (platform === Platforms.IOS || platform === Platforms.MAC) {
    return <IconShareIOS {...props} />;
  }

  if (platform === Platforms.ANDROID) {
    return <IconShareAndroid {...props} />;
  }

  return <IconShareGeneral {...props} />;
};
